import React from "react";
import * as S from "./style";
import moment from "moment-timezone";
import { formatPrice } from "utils/formatPrice";
import useWindowSize, { Size } from "hooks/useWindowSize";
interface Props {
  data?: ArtTop10CardItemProps;
  flipped?: boolean;
}
interface ArtTop10CardItemProps {
  id: number;
  authorName: string;
  productName: string;
  exhibitionDestination: string;
  price: string;
  tradeDay: string;
  rank: number;
}

const ArtTop10CardItem = ({ data, flipped = false }: Props) => {
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 767;
  const isMobile567 = size.width && size.width <= 567;

  return isMobile ? (
    <S.CardContent flipped={flipped}>
      <div className="card">
        <div className="badge">{data?.rank}위</div>
        <div className="content">
          {isMobile567 ? (
            <>
              <div className="exhibition">
                출품처: {data?.exhibitionDestination}
              </div>
              <div className="author">{data?.authorName || "작자미상"}</div>
            </>
          ) : (
            <div className="top">
              <div className="author">{data?.authorName || "작자미상"}</div>
              <div className="exhibition">
                출품처: {data?.exhibitionDestination}
              </div>
            </div>
          )}

          <div className="product">{data?.productName || "\u00A0"}</div>
          <div className="line"></div>
          <div className="price">
            <div className="key">
              낙찰가:{formatPrice(Number(data?.price) || 0)}원
            </div>
            <div className="value">
              거래일: {moment(data?.tradeDay).format("YYYY.MM.DD")}
            </div>
          </div>
        </div>
      </div>
    </S.CardContent>
  ) : (
    <S.CardContent flipped={flipped}>
      <div className="card">
        <div className="badge">{data?.rank}위</div>
        <div className="content">
          <div className="left">
            <div className="author">{data?.authorName || "작자미상"}</div>
            <div className="product">{data?.productName || "\u00A0"}</div>
          </div>
          <div className="right">
            <div className="exhibition">
              <div>출품처: {data?.exhibitionDestination}</div>
              <div>|</div>
            </div>
            <div className="price">
              <div className="key">낙찰가:</div>
              <div className="value">
                <div>{formatPrice(Number(data?.price) || 0)}원</div>
                <div>거래일: {moment(data?.tradeDay).format("YYYY.MM.DD")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </S.CardContent>
  );
};

export default ArtTop10CardItem;
